












import { RuleInterface } from '../../../types'
import Vue from 'vue'

export default Vue.extend({
  name: 'Answer',

  props: {
    rules: {
      required: true,
      type: Array as () => Array<RuleInterface>
    },

    rulesLength: {
      required: true,
      type: Number
    }
  },

  data: () => ({
    attempt: [] as Array<number>
  }),

  watch: {
    attempt(value: Array<number>) {
      this.$emit('attempt', value)
    },

    rules() {
      this.mountInitialAttempt()
    }
  },

  mounted() {
    this.mountInitialAttempt()
  },

  methods: {
    decrease(index: number) {
      this.attempt[index] > 0
        ? this.$set(this.attempt, index, this.attempt[index] - 1)
        : this.$set(this.attempt, index, 9)
    },

    increase(index: number) {
      this.attempt[index] < 9
        ? this.$set(this.attempt, index, this.attempt[index] + 1)
        : this.$set(this.attempt, index, 0)
    },

    mountInitialAttempt() {
      this.attempt = Array(this.rulesLength).fill(0)
    }
  }
})
